// Pure TypeScript zero-dependency client-side ZIP generator

function crc32(buffer: Uint8Array): number {
  let crc = 0xffffffff;
  for (let i = 0; i < buffer.length; i++) {
    const byte = buffer[i];
    crc ^= byte;
    for (let j = 0; j < 8; j++) {
      crc = (crc >>> 1) ^ (crc & 1 ? 0xedb88320 : 0);
    }
  }
  return (crc ^ 0xffffffff) >>> 0;
}

export async function createZipBlob(files: { name: string; dataUrl: string }[]): Promise<Blob> {
  const fileEntries: {
    nameBytes: Uint8Array;
    contentBytes: Uint8Array;
    crc: number;
    size: number;
    offset: number;
  }[] = [];

  const encoder = new TextEncoder();
  let currentOffset = 0;

  for (const file of files) {
    const base64 = file.dataUrl.split(',')[1] || '';
    const binaryStr = atob(base64);
    const contentBytes = new Uint8Array(binaryStr.length);
    for (let i = 0; i < binaryStr.length; i++) {
      contentBytes[i] = binaryStr.charCodeAt(i);
    }

    const nameBytes = encoder.encode(file.name);
    const crc = crc32(contentBytes);
    const size = contentBytes.length;

    fileEntries.push({
      nameBytes,
      contentBytes,
      crc,
      size,
      offset: currentOffset,
    });

    currentOffset += 30 + nameBytes.length + size;
  }

  const centralDirOffset = currentOffset;
  let centralDirSize = 0;

  for (const entry of fileEntries) {
    centralDirSize += 46 + entry.nameBytes.length;
  }

  const totalSize = centralDirOffset + centralDirSize + 22;
  const buffer = new Uint8Array(totalSize);
  const view = new DataView(buffer.buffer);

  let offset = 0;

  for (const entry of fileEntries) {
    view.setUint32(offset, 0x04034b50, true);
    view.setUint16(offset + 4, 20, true);
    view.setUint16(offset + 6, 0, true);
    view.setUint16(offset + 8, 0, true);
    view.setUint16(offset + 10, 0, true);
    view.setUint16(offset + 12, 0, true);
    view.setUint32(offset + 14, entry.crc, true);
    view.setUint32(offset + 18, entry.size, true);
    view.setUint32(offset + 22, entry.size, true);
    view.setUint16(offset + 26, entry.nameBytes.length, true);
    view.setUint16(offset + 28, 0, true);

    offset += 30;
    buffer.set(entry.nameBytes, offset);
    offset += entry.nameBytes.length;
    buffer.set(entry.contentBytes, offset);
    offset += entry.size;
  }

  for (const entry of fileEntries) {
    view.setUint32(offset, 0x02014b50, true);
    view.setUint16(offset + 4, 20, true);
    view.setUint16(offset + 6, 20, true);
    view.setUint16(offset + 8, 0, true);
    view.setUint16(offset + 10, 0, true);
    view.setUint16(offset + 12, 0, true);
    view.setUint16(offset + 14, 0, true);
    view.setUint32(offset + 16, entry.crc, true);
    view.setUint32(offset + 20, entry.size, true);
    view.setUint32(offset + 24, entry.size, true);
    view.setUint16(offset + 28, entry.nameBytes.length, true);
    view.setUint16(offset + 30, 0, true);
    view.setUint16(offset + 32, 0, true);
    view.setUint16(offset + 34, 0, true);
    view.setUint16(offset + 36, 0, true);
    view.setUint32(offset + 38, 0, true);
    view.setUint32(offset + 42, entry.offset, true);

    offset += 46;
    buffer.set(entry.nameBytes, offset);
    offset += entry.nameBytes.length;
  }

  view.setUint32(offset, 0x06054b50, true);
  view.setUint16(offset + 4, 0, true);
  view.setUint16(offset + 6, 0, true);
  view.setUint16(offset + 8, fileEntries.length, true);
  view.setUint16(offset + 10, fileEntries.length, true);
  view.setUint32(offset + 12, centralDirSize, true);
  view.setUint32(offset + 16, centralDirOffset, true);
  view.setUint16(offset + 20, 0, true);

  return new Blob([buffer], { type: 'application/zip' });
}
